import { createFileRoute } from "@tanstack/react-router";
import { SettingsOverview } from "@/components/views";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createFileRoute("/$workspaceId/settings/")({
	component: RouteComponent,
});

function RouteComponent() {
	const { workspaceId } = Route.useParams();
	const { session, currentWorkspace } =
		Route.useRouteContext() as RouterAppContext;
	
	return (
		<SettingsOverview
			workspaceId={workspaceId}
			session={session}
			currentWorkspace={currentWorkspace}
		/>
	);
}